export type {
    FilterField,
    FilterOperator,
    LogicalOperator,
    FilterCondition,
    FilterGroup,
    AdvancedFilter as AdvancedFilterQuery,
} from '@packages/schemas';

export {
    FilterFieldEnum,
    FilterOperatorEnum,
    LogicalOperatorEnum,
    FilterConditionSchema,
    FilterGroupSchema,
    AdvancedFilterSchema,
    FilterField as FilterFieldConstants,
    FilterOperator as FilterOperatorConstants,
    LogicalOperator as LogicalOperatorConstants,
} from '@packages/schemas';

export type Filters = {
    skip?: number;
    take?: number;
    search?: string;
    orderBy?: string;
    orderDirection?: 'asc' | 'desc';
};
